class SwiperPostRelated extends HTMLElement {
    constructor() {
        super();
        console.log(this)
        this.swiper = null;
        this.swiperOptions = {
            slidesPerView: 1,
            spaceBetween: 4,
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                750: {
                    slidesPerView: 2,
                },
                1400: {
                    slidesPerView: 4,
                },
            },
        };
    }

    connectedCallback() {
        console.log(this)
        this.swiper = new Swiper(this.querySelector('.swiper-container'), this.swiperOptions);
    }

    disconnectedCallback() {
        this.swiper.destroy();
    }
}

customElements.define('swiper-post-related', SwiperPostRelated);